const initialState = {
  input_page: false,
  confirm_page: false,
  result_page: false,
  error_page: false,
  validateError: false,
  isRequesting: true,
  token: '',
  form_settings: {
    fields: [],
    form_text: {}
  },
  form: {},
  validationErrors: {}
};

export default initialState;
